import {useEffect} from 'react';

/**
 * Sezzle Script Added to site.
 */
export function Sezzle() {
  const windowReady = typeof window !== 'undefined';

  useEffect(() => {
    var sezzle = document.createElement('script');
    sezzle.type = 'text/javascript';
    sezzle.async = true;
    sezzle.src =
      ('https:' == document.location.protocol ? 'https://' : 'http://') +
      'widget.sezzle.com/v1/javascript/price-widget?uuid=73dac340-c9ab-4d60-bd0d-09e60e854f47';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(sezzle, s);
  }, [windowReady]);

  return null;
}
